export enum InteractionSubject {
  Product = "Product",
  Vendor = "Vendor",
}

export enum InteractionType {
  Scan = "Scan",
  View = "View",
  AddToCollection = "AddToCollection",
}

export enum InteractionPlatform {
  Web = "Web",
  WebIos = "WebIos",
  WebAndroid = "WebAndroid",
  WebMobile = "WebMobile",
  IOS = "IOS",
  Android = "Android",
  Unknown = "Unknown",
}

export interface Interaction {
  id: number;
  created_at: string;
  type: InteractionType;
  subject: InteractionSubject;
  product: {
    name: string;
  };
  user: {
    id: string;
    email: string;
  };
  account: {
    id: string;
    name: string;
  };
  collection?: {
    collection_type: string;
  };
}

const getCurrentInteractionPlatform = () => {
  const ua = navigator.userAgent;

  if (ua.includes("iPhone") || ua.includes("iPad")) {
    return InteractionPlatform.WebIos;
  } else if (ua.includes("Android")) {
    return InteractionPlatform.WebAndroid;
  } else if (screen.width <= 768 || screen.height <= 768) {
    return InteractionPlatform.WebMobile;
  } else {
    return InteractionPlatform.Web;
  }
};

export const currentInteractionPlatform = getCurrentInteractionPlatform();
